//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductContext} from '../../../context';
import {useEditProduct} from '../../../utils/editProduct';
import {debounce} from '../../../../../utils/functions';

const useStyles = makeStyles(theme => ({
  numberField: {
    width: '96px',
  },
}));

export default function ProductOfferPriceCell() {
  const classes = useStyles();

  const [product, setProduct] = useProductContext(product => {
    const taxes = product.taxes ?? [];
    const categoryTaxes = product.categoryTaxes ?? [];

    return {
      id: product.id,
      offerPrice: product.offerPrice,
      enabledProductVariant: !!product.productVariantSetting?.enabled,
      hasVariants:
        product.productVariantSetting?.variants &&
        product.productVariantSetting.variants.length > 0,
      taxes: [...taxes, ...categoryTaxes]
        .map(parseFloat)
        .reduce((acc, curr) => acc + curr, 1),
    };
  }, false);

  const {editProduct} = useEditProduct(product ? product.id : '');

  const hasVariants = product.enabledProductVariant && product.hasVariants;

  const handleChange = price => {
    const withTaxPrice =
      price === '' ? '' : parseFloat(Number(price) * product.taxes).toFixed(5);
    const offerPriceSetting = {
      offerPrice: withTaxPrice || undefined,
      enabled: withTaxPrice ? true : false,
    };
    setProduct({
      offerPriceSetting,
      offerPrice: price,
      taxedOfferPrice: withTaxPrice,
    });

    debounce(_ => {
      if (!price && price !== '') return;

      editProduct({
        offerPriceSetting,
      });
    }, 750)();
  };

  return (
    <TableCell align="right">
      <CustomTextField
        name="offer-price"
        className={classes.numberField}
        type="number"
        value={product.offerPrice}
        disabled={hasVariants}
        defaultValue={product.offerPrice}
        inputProps={{
          step: '0.01',
        }}
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
